import * as types from '../../../actions/actiontypes';
import initialstate from '../../initialstate';
import moment from 'moment';
import _ from 'lodash';

export default function viewInstructionsReducer(state = initialstate.viewInstructions, action) {
	switch (action.type) {
		case types.LOAD_INSTRUCTIONS: {
			if (action.response) {
				let instructions = [...action.response];
				instructions = _.sortBy(instructions, function(o) {
					return new moment(o.acceptDate);
				}).reverse();

				return [...instructions];
			} else return state;
		}
		default:
			return state;
	}
}
